module.exports = __webpack_public_path__ + "static/media/helixx.da049265.mp4";